const Region_USA = "usa";

class TaxRegion {
  get name() {
  }

  get maxLevels() {
  }

  /**
   *
   * @param level {int}
   * @return {int}
   */
  getGroupNamesAtLevel(level) {
  }

  _currentGroups = {};

  get allGroups(){
  }

  getCurrentGroupAtLevel(level) {
    return this._currentGroups[level];
  }

  setCurrentGroupAtLevel(level, group) {
    this._currentGroups[level] = group;
  }

  canGroupHaveSubGroups(group) {
  }
}

class TaxRegionUSA extends TaxRegion {
  groups = ['State', 'County', 'City'];

  constructor(){
    super();

    this._currentGroups[0] = this.groups[0];
    this._currentGroups[1] = this.groups[1];
    this._currentGroups[2] = this.groups[2];
  }

  get name() {
    return Region_USA;
  }

  get maxLevels(){
    return 3;
  }

  getGroupNamesAtLevel(level) {
    switch (level) {
      case 0:
        return [this.groups[0]];
      case 1:
        return this.groups.slice(1, 3);
      case 2:
        return [this.groups[2]];
    }
  }

  get allGroups(){
    return this.groups;
  }

  canGroupHaveSubGroups(group) {
    return group !== this.groups[2];
  }
}

class TaxesRegions {
  static regions = [new TaxRegionUSA()];

  static _currentRegion = null;

  static getAvailableRegions() {
    return TaxesRegions.regions;
  }

  /**
   *
   * @return {TaxRegion}
   */
  static get currentRegion() {
    if (!TaxesRegions._currentRegion)
      TaxesRegions._currentRegion = TaxesRegions.regions[0];
    return  TaxesRegions._currentRegion;
  }

  static setCurrentRegion(region) {
    TaxesRegions._currentRegion = region;
  }
}

export default TaxesRegions;
